// extracted by mini-css-extract-plugin
export default {"link":"uE-z","disabled":"vE-z"};